<template lang="pug">
.simple-entity-search(ref="simpleEntitySearch")
  v-autocomplete(
    :value="selectedEntity",
    @input="selectEntity",
    :search-input.sync="search",
    placeholder="Search By",
    item-value="uid",
    :class="{ 'column--is-menu-active': menuIsActive }",
    :item-text="getResultText",
    append-icon="",
    dense,
    rounded,
    hide-no-data,
    hide-selected,
    return-object,
    no-filter,
    @click="requireColumn",
    v-bind="{ loading, items, errorMessages }",
  )
    template(v-slot:prepend)
      .prepend-slot.d-flex
        v-btn(
          color="secondary",
          fab,
          dark,
          x-small,
          elevation="0",
        )
          v-icon(dark) mdi-magnify
        h6.column__label(:class="[hasColumn ? 'primary--text' : 'icon--text']") {{ (selectedColumn || {}).label }}
    template(v-slot:append-outer)
      v-menu(
        @input="menuIsActive = $event",
        content-class="columnMenu",
      )
        template(v-slot:activator="{ on, attrs }")
          v-btn(
            ref="columnMenuBtn",
            color="secondary",
            fab,
            dark,
            x-small,
            elevation="0",
            v-on="on",
            v-bind="attrs",
          )
            v-icon(dark) mdi-chevron-down
        v-list
          v-list-item(
            v-for="(item, index) in validColumnItems",
            :key="index",
            link,
            @click="selectedColumn = item",
          )
            v-list-item-title {{ item.label }}
</template>

<style lang="scss" scoped>
.simple-entity-search {
  box-shadow: 2px 2px 10px 0px rgba(220, 220, 220, 0.25);
  position: relative;
  ::v-deep .v-menu__content {
    border-radius: 0 0 10px 10px;

    &.v-autocomplete__content {
      border: solid var(--v-iconRounded-base);
      top: 40px !important;
      left: 0 !important;
      max-width: 100%;
      width: 100%;
      border-width: 0 1px 1px 1px;
      box-shadow: 2px 2px 10px 0px rgba(99, 88, 88, 0.15);

      &:before {
        content: '';
        position: absolute;
        top: 0;
        margin-left: 1%;
        width: 98%;
        height: 1px;
        background: var(--v-text-base);
      }
    }

    &.columnMenu {
      box-shadow: 2px 2px 7px 1px rgba(99, 88, 88, 0.15);
      top: 42px !important;
      transform-origin: right top;
      left: auto !important;
      right: 0 !important;
      z-index: 9 !important;
    }
  }

  ::v-deep .v-autocomplete {
    border: 1px solid var(--v-iconRounded-base);
    border-radius: 10px;
    padding: 0 10px;
    margin-top: 0;
    background-color: #ffffff;

    &.v-select--is-menu-active,
    &.column--is-menu-active {
      border-radius: 10px 10px 0 0;
    }

    .v-input__control {
      .v-input__slot {
        padding: 0;
        margin: 0;
        .v-select__slot {
          input:first-child {
            padding-top: 13px;
            padding-bottom: 0px;
            line-height: 14px;
            font-size: 12px;
          }
        }
      }
      .v-text-field__details,
      .v-messages {
        min-height: 13px;
        // display: none;
      }
    }
    .prepend-slot {
      .column__label {
        margin-left: 10px;
        line-height: 14px;
        font-size: 12px;
        padding-top: 8px;
        white-space: nowrap;
      }
    }
    .v-input__prepend-outer, .v-input__append-outer {
      margin-top: 5px;
      .v-btn--fab {
        height: 25px;
        width: 25px;
      }
    }
  }
}
</style>

<script>
import axios from 'axios';

export default {
  name: 'simple-entity-search',
  props: {
    'entity': {
      type: Object,
      default: () => ({})
    },
    'loads': {
      type: Array,
      default: () => ([])
    },
    'wheres': {
      type: Array,
      default: () => ([])
    },
    'disabled': null,
    'value': null,
    'errorMessages': null,
    'schemaFilter': {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      selectedEntity: this.value,
      timer: 0,
      wait: 500,
      pagination: {},
      hasColumn: false,

      columnItems: [
        {
          label: 'External ID',
          value: 'externalId',
        },
        {
          label: 'Name',
          value: 'name',
        },
      ],

      menuIsActive: false,
      loading: false,
      items: [],
      selectedColumn: null,

      search: null,
    }
  },
  watch: {
    search (val) {
      val && val !== this.getResultText(this.selectedEntity) && this.searchItems(val);
    },
  },
  computed: {
    allColumnItems() {
      return [...this.columnItems, ..._.get(ENV.ENTITIES, (this.entity || {}).name  + '.searchColumns', [])];
    },
    validColumnItems() {
      return _.reduce(this.allColumnItems, (acc, col) => {
        const needsFiltering = this.isRootColumn(col);
        if (!this.schemaFilter || !needsFiltering || _.find(this.entityFields, ['name', col.value])) {
          acc.push(col);
        }
        return acc;
      }, []);
    },
    entityFields() {
      return _.get(this.entity, 'fields', []);
    },
    entityFieldsDebug() {
      return this.entityFields.map(x => x.name);
    },
    searchingLoad() {
      const selectedColumnPath = _.get(this.selectedColumn, 'value');
      if (selectedColumnPath) {
        let load = selectedColumnPath.split('.');
        if (load.length > 1) {
          load.pop();
          return [load.join('.')];
        }
      }
      return [];
    },
  },
  methods: {
    isRootColumn({ value }) {
      return value && (value.split('.').length === 1);
    },
    requireColumn(e) {
      if (!this.selectedColumn) {
        e.stopPropagation(e);
        e.preventDefault();
        this.$refs['columnMenuBtn'].$el.click();
      }
    },
    selectEntity(value) {
      this.search = null;
      this.selectedEntity = value;
      this.$emit('input', { ...value, entityState: value._Entity != 'BusinessScope' ? 3 : value.entityState });
    },
    getResultText(x) {
      if (!x) return '';
      const searchTextAttr = _.get(ENV.ENTITIES, (this.entity || {}).name  + '.searchTextAttr', []);
      const idAttribute = _.get(x, searchTextAttr) || x.externalId || x.uid;
      const selectedColumnV = _.get(this.selectedColumn, 'value');
      const searchedAttribute = _.get(x, selectedColumnV);

      if (selectedColumnV == 'externalId') return `${searchedAttribute}`;
      return `${searchedAttribute} (${idAttribute})`;
    },
    async searchItems (search) {
      try {
        const searchWhere = this.createWhere(_.get(this.selectedColumn, 'value'), search);
        const propWhere = this.wheres ? [...this.wheres] : [];
        this.loading = true;
        clearTimeout(this.timer);
        this.timer = setTimeout(async () => {
          this.items = (await axios.get(this.entity.name, { params: { pageSize: 100, where: searchWhere ? [searchWhere, ...propWhere] : [...propWhere], load: [...this.loads, ...this.searchingLoad] }})).data.data;
          this.loading = false;
        }, this.wait);
      } catch (e) {
        console.log(this.$cleanString(e));
      }
    },
    createWhere(column, search) {
      if (!column || !search) return null;
      return `${column}.Contains("${search}")`;
    },
  },
}
</script>
